import React, { useEffect } from "react";
// import { Navbar3 } from "../../../Components/Brand/Navbar/Navbar";
import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "../../../Providers/Auth";
import { DashBoard } from "../DashBoard/Discover/DashBoard";
import { ScreenAlert } from "../../SmallScreenAlert/ScreenAlert";

import { CreditHistory } from "../DashBoard/CreditsHistory/CreditHistory";
import { PurchaseCredits } from "../DashBoard/PurchaseCredits/PurchaseCredits";
import { UnlockedCreators } from "../DashBoard/UnlockedCreators/UnlockedCreators";
import { UnlockedCreatorFull } from "../DashBoard/UnlockedCreators/UnlockedCreatorFull";
import { PurchaseCreditsSucess } from "../DashBoard/PurchaseCredits/PurchaseCreditsSucess";
import { UnlockedCreatorFullSample } from "../DashBoard/UnlockedCreators/UnlockedCreatorFullSample";
import { UnlockCreatorSearch } from "../DashBoard/UnlockCreatorSearch/UnlockCreatorSearch";
import { LockedCreatorDetails } from "../DashBoard/LockedCreatorDetails/LockedCreatorDetails";
import { PromoteAdNewCampaign } from "../DashBoard/PromoteAd/NewCampaign";
import { PromoteAdDashboard } from "../DashBoard/PromoteAd/Dashboard";
import { LiveCampaign } from "../DashBoard/PromoteAd/LiveCampaign";
import { FeedbackPage } from "../DashBoard/Feedback/Feedback";
import { NewDashBoard } from "../DashBoard/NewDashBoard/NewDashBoard";
import BrandPaymentHistory from "../DashBoard/PaymentHistory/PaymentHistoryV2";
import { SidebarProvider } from "@/shadcnComponents/ui/sidebar";
import { AppSidebar } from "@/Components/Brand/SidebarV2/app-sidebar";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shadcnComponents/ui/breadcrumb";
import { Separator } from "@/shadcnComponents/ui/separator";
import { SidebarTrigger } from "@/shadcnComponents/ui/sidebar";
import { platformItems } from "@/Components/Brand/SidebarV2/nav-main";
import BrandPricingV2 from "../Pricing/PricingV2/PricingV2";
import { CalendarDashboard } from "../DashBoard/calendar/calendar-dashboard";
import { NewCampaignProvider } from "../DashBoard/PromoteAd/CustomHooks/NewCampaignHooks";
import CollabWithMePage from "../DashBoard/CollabWithMe/CollabWithMe";
import { SampleModeBanner } from "../SampleCampaign/sample-mode-banner";

const BrandHome: React.FC = () => {
  const authState = useAuth();
  const UserType = localStorage.getItem("UserType");

  useEffect(() => {
    if (localStorage.getItem("UserType") === "Influencer") {
      window.open("/brand", "_self");
    }
  }, [UserType]);

  const hideSidebar = () => {
    return (
      window.location.pathname
        ?.toLowerCase()
        .includes("/brand/dashboard/allcampaign/draft") ||
      window.location.pathname
        ?.toLowerCase()
        .includes("/brand/dashboard/allcampaign/campaign")
    );
  };

  return (
    <>
      {authState?.loggedBrand?.status === 0 ? (
        <Routes></Routes>
      ) : window.screen.width > 600 ? (
        <>
          <SidebarProvider>
            <div className="flex w-screen overflow-hidden">
              {!hideSidebar() && <AppSidebar />}

              <div className="flex w-full h-full flex-1 flex-col overflow-hidden">
                {!hideSidebar() && (
                  <header className="flex h-16 shrink-0 items-center border-b px-4 md:px-6">
                    <div className="flex items-center gap-2">
                      <SidebarTrigger className="-ml-2" />
                      <Separator orientation="vertical" className="h-6" />
                      <Breadcrumb>
                        <BreadcrumbList>
                          <BreadcrumbItem>
                            <BreadcrumbLink>Home</BreadcrumbLink>
                          </BreadcrumbItem>
                          <BreadcrumbSeparator />
                          <BreadcrumbItem>
                            <BreadcrumbPage>
                              {
                                platformItems?.find(
                                  (item) =>
                                    item?.url === window?.location.pathname
                                )?.title
                              }
                            </BreadcrumbPage>
                          </BreadcrumbItem>
                        </BreadcrumbList>
                      </Breadcrumb>
                    </div>
                  </header>
                )}
                {!hideSidebar() && authState?.loggedBrand?.isSampleBrand && (
                  <SampleModeBanner />
                )}
                <div className="bg-[#EEE] w-full  overflow-y-auto overflow-x-hidden">
                  <Routes>
                    <Route
                      path="*"
                      element={<Navigate to={"/Brand/DashBoard"} />}
                    />
                    <Route path="/DashBoard" element={<NewDashBoard />} />
                    <Route
                      path="/DashBoard/AllCampaign"
                      element={<PromoteAdDashboard />}
                    />
                    <Route
                      path="/DashBoard/Calendar"
                      element={<CalendarDashboard />}
                    />

                    <Route path="/DashBoard/Discover" element={<DashBoard />} />

                    {/* ------- payment history -------- */}
                    {/* <Route
                    path="/DashBoard/PaymentHistory"
                    element={<PaymentHistory />}
                  /> */}
                    <Route
                      path="/DashBoard/PaymentHistory"
                      element={<BrandPaymentHistory />}
                    />

                    {/* ----- Feedback -------------- */}
                    <Route
                      path="/DashBoard/Feedback"
                      element={<FeedbackPage />}
                    />

                    <Route
                      path="/DashBoard/AllCampaign/Draft/:collabId"
                      element={
                        <NewCampaignProvider>
                          <PromoteAdNewCampaign />
                        </NewCampaignProvider>
                      }
                    />
                    <Route
                      path="/DashBoard/AllCampaign/Campaign/:collabId"
                      element={<LiveCampaign />}
                    />

                    <Route
                      path="/DashBoard/CreditsHistory"
                      element={<CreditHistory />}
                    />
                    <Route
                      path="/DashBoard/PurchaseCredits"
                      element={<PurchaseCredits />}
                    />
                    <Route
                      path="/DashBoard/PurchaseCredits/Success"
                      element={<PurchaseCreditsSucess />}
                    />
                    <Route
                      path="/DashBoard/UnlockedInfluencer"
                      element={<UnlockedCreators />}
                    />
                    <Route
                      path="/DashBoard/UnlockInfluencerSearch"
                      element={<UnlockCreatorSearch />}
                    />
                    <Route
                      path="/DashBoard/CollabWithInfluencer"
                      element={<CollabWithMePage />}
                    />
                    <Route
                      path="/DashBoard/UnlockedInfluencer/Details"
                      element={<UnlockedCreatorFull />}
                    />
                    <Route
                      path="/DashBoard/UnlockedInfluencer/Sample"
                      element={<UnlockedCreatorFullSample />}
                    />
                    <Route
                      path="/DashBoard/l/profile/:id"
                      element={<LockedCreatorDetails />}
                    />
                    <Route
                      path="/DashBoard/pricing"
                      element={<BrandPricingV2 />}
                    />
                  </Routes>
                </div>
              </div>
            </div>
          </SidebarProvider>
        </>
      ) : (
        <Routes>
          <Route path="*" element={<ScreenAlert />} />
        </Routes>
      )}
    </>
  );
};

export default BrandHome;
